module.exports = "<app-header></app-header>\n<div>\n  <router-outlet></router-outlet>\n</div>\n"